import { useState, useEffect, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import {
    FetchPlantSearchNew,
    FetchDeviceStatusNew,
} from '../../../services/api'
import { fetchIssues } from '../../IssueManagement/services/issueService'
import dayjs from 'dayjs'

export const useSolarPlantList = () => {
    const navigate = useNavigate()
    const [plantlist, sePlantlist] = useState([])
    const [sortDate, setSortDate] = useState(dayjs())
    const [deviceStatus, setDeviceStatus] = useState({})
    const [deviceStatusLoading, setDeviceStatusLoading] = useState({})
    const [selectedValue, setSelectedValue] = useState('')
    const [searchName, setSearchName] = useState('')
    const [loading, setLoading] = useState(true)
    const [plantSizeOrder, setPlantSizeOrder] = useState(true)
    const [issueCounts, setIssueCounts] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(25)
    const [isMonitoring, setIsMonitoring] = useState(true)
    const [totalPlants, setTotalPlants] = useState(0)
    const headerRef = useRef(null)

    const token = localStorage.getItem('accessToken')

    const handleSearch = (e) => {
        setSearchName(e.target.value)
    }

    const handleSelectChange = (event) => {
        setSelectedValue(event.target.value)
    }

    const handleMonitoringToggle = () => {
        setCurrentPage(1)
        setIsMonitoring(!isMonitoring)
    }

    const HandleSortPlant = () => {
        setPlantSizeOrder(!plantSizeOrder)
    }

    const handleChangeDate = (value) => {
        setSortDate(value)
    }

    const updateDeviceStatus = useCallback((plantId) => {
        if (!plantId || plantId === 'undefined' || !token) return

        setDeviceStatusLoading((prev) => ({ ...prev, [plantId]: true }))
        FetchDeviceStatusNew(plantId, token)
            .then((resp) => {
                if (resp?.data) {
                    setDeviceStatus((prev) => ({ ...prev, [plantId]: resp.data.data }))
                }
            })
            .catch((error) => {
                console.error('Error fetching device status:', error)
            })
            .finally(() => {
                setDeviceStatusLoading((prev) => ({ ...prev, [plantId]: false }))
            })
    }, [token])

    const loadIssueCounts = useCallback(async () => {
        if (!token) return
        try {
            const issues = await fetchIssues(token)
            const counts = {}
            if (Array.isArray(issues)) {
                issues.forEach((issue) => {
                    if (['Open', 'Under Review', 'Material Awaited', 'OEM', 'In Progress', 'Resolved'].includes(issue.status)) {
                        counts[issue.plantId] = (counts[issue.plantId] || 0) + 1
                    }
                })
            }
            setIssueCounts(counts)
        } catch (error) {
            console.error('Error loading issue counts:', error)
        }
    }, [token])

    const handleTechnicalView = (data) => {
        const deviceStatusForPlant = deviceStatus[data?.id] || {}
        navigate('/TechnicalView', {
            state: {
                data,
                token: token,
                selectedDate: sortDate.format('DD-MM-YYYY'),
                totalEToday: data?.totalEToday !== null ? parseFloat(data?.totalEToday).toFixed(2) : 0,
                dailyEnergy: data?.dailyEnergy !== null ? parseFloat(data?.dailyEnergy).toFixed(2) : 0,
                deviceCounts: {
                    inverters: deviceStatusForPlant?.devices?.inverters ?? 0,
                    energyMeters: deviceStatusForPlant?.devices?.energyMeters ?? 0,
                    sensors: deviceStatusForPlant?.devices?.sensors ?? 0,
                    dataLoggers: deviceStatusForPlant?.devices?.dataLoggers ?? 0,
                },
            },
        })
    }

    const handleAddnewplant = () => {
        navigate('/addnewplant', { state: { token: token } })
    }

    const handleSolarMapView = () => {
        navigate('/SolarMapView')
    }

    const handleADDdevice = () => {
        navigate('/Devicelist', { state: { plantlist, token: token } })
    }

    const handlePlantreport = () => {
        navigate('/plantreport', { state: { plantlist, token: token } })
    }

    const handleViewIssues = (plantId, plantName) => {
        navigate(`/issue-management?plantId=${plantId}&plantName=${encodeURIComponent(plantName)}`)
    }

    const handleBusinessView = (data) => {
        navigate('/BusinessView', {
            state: {
                data,
                token: token,
                selectedDate: sortDate.format('DD-MM-YYYY'),
            },
        })
    }

    useEffect(() => {
        if (!token) return
        const Order = plantSizeOrder ? '1' : '-1'
        setLoading(true)
        FetchPlantSearchNew(
            sortDate.format('YYYY-MM-DD'),
            searchName,
            selectedValue,
            token,
            Order,
            isMonitoring,
            currentPage,
            rowsPerPage
        ).then((resp) => {
            if (resp?.data) {
                sePlantlist(resp.data.data)
                if (resp.data.total !== undefined) {
                    setTotalPlants(resp.data.total)
                }
            }
            setLoading(false)
        })
    }, [searchName, selectedValue, plantSizeOrder, isMonitoring, sortDate, token, currentPage, rowsPerPage])

    useEffect(() => {
        if (token) {
            loadIssueCounts()
            const intervalId = setInterval(loadIssueCounts, 300000)
            return () => clearInterval(intervalId)
        }
    }, [loadIssueCounts, token])

    // Pagination
    const currentRows = plantlist || []
    const totalPages = Math.ceil(totalPlants / rowsPerPage)

    return {
        plantlist,
        currentRows,
        loading,
        isMonitoring,
        handleMonitoringToggle,
        searchName,
        handleSearch,
        sortDate,
        handleChangeDate,
        selectedValue,
        handleSelectChange,
        plantSizeOrder,
        HandleSortPlant,
        deviceStatus,
        deviceStatusLoading,
        updateDeviceStatus,
        issueCounts,
        handleViewIssues,
        handleTechnicalView,
        handleAddnewplant,
        handleSolarMapView,
        handleADDdevice,
        handlePlantreport,
        currentPage,
        setCurrentPage,
        rowsPerPage,
        setRowsPerPage,
        totalPages,
        totalPlants,
        headerRef,
        token,
        handleBusinessView
    }
}

